import { render } from "./termsOfUse.vue?vue&type=template&id=0574f266&scoped=true"
import script from "./termsOfUse.vue?vue&type=script&lang=js"
export * from "./termsOfUse.vue?vue&type=script&lang=js"

import "./termsOfUse.vue?vue&type=style&index=0&id=0574f266&scoped=true&lang=sass"
import "./termsOfUse.vue?vue&type=style&index=1&id=0574f266&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0574f266"]])

export default __exports__